import React from 'react';
import {
    PropsShell,
    PropsNotFound,
    PropsCommonFields,
    PropsOptionsEditor,
    PropsRequiredAndMeta,
    useQuestionProperties,
} from './QuestionPropertiesShared';

const SingleChoiceBlockProperties = ({ questionId }) => {
    const { question, localName, nameError, handleUpdate, handleNameChange } =
        useQuestionProperties(questionId);

    if (!question) return <PropsNotFound />;

    return (
        <PropsShell typeLabel="Radio group" typeIcon="bi-ui-radios">
            <PropsCommonFields
                localName={localName}
                nameError={nameError}
                onNameChange={handleNameChange}
                title={question.title}
                description={question.description}
                onTitleChange={(value) => handleUpdate('title', value)}
                onDescriptionChange={(value) => handleUpdate('description', value)}
            />

            <PropsOptionsEditor
                options={question.options}
                onChange={(options) => handleUpdate('options', options)}
            />

            <PropsRequiredAndMeta
                required={question.required}
                onRequiredChange={(value) => handleUpdate('required', value)}
                questionId={questionId}
            />
        </PropsShell>
    );
};

export default SingleChoiceBlockProperties;
